<template>
  <div>
    <div class="container_wrap"></div>
  </div>
</template>
<script>
export default {
  name: "DeBounce",
  data() {
    return {};
  },
  props: {
    bottom: {//距离底部的距离
      type: Number,
      default: 346,
    },
    fetchFun: {//执行函数
      type: Function,
      default: () => {
        console.log(123);
      },
    },
    pagefetchflag:{//是否发起的标志
        type:Boolean,
        default:true
    },
    delaytime:{//延时
        type:Number,
        default:500
    }
  },
  mounted() {
    this.debounceFn = this.debounce(this.scrollChange, this.delaytime);
    window.addEventListener("scroll", this.debounceFn);
  },
  methods: {
    debounceFn() {},
    debounce(fn, delay) {
      let timer = null;
      return function (params) {
        let context = this;
        let args = arguments;
        if (timer) {
          clearTimeout(timer);
        }
        timer = setTimeout(() => {
          fn.apply(context, args);
        }, delay);
      };
    },
    scrollChange() {
      if (
        document.documentElement.scrollHeight -
          document.documentElement.scrollTop -
          document.documentElement.clientHeight <=
            this.bottom
      ) {
        if (!this.pagefetchflag) {
          return;
        }
        //发起网络请求// fetch data
        this.fetchFun();
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.debounceFn);
  },
};
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// DeBounce.vue?4286a5f0